import { yupResolver } from "@hookform/resolvers/yup";
import moment from "moment";
import React, { Fragment, useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { Card, CardText, Col, Container, Form, FormGroup, Input, Label, Row } from "reactstrap";
import * as yup from "yup";
import "yup-phone";
import Breadcrumbs from "../../../../layout/breadcrumb";
import ButtonLoader from "../../../../share-components/ui/buttonLoader";
import PreLoader from "../../../../share-components/ui/preLoader";
import withReducer from "../../../../store/withReducer";
import LogActivity from "../../../log";
import partnerPromotionReducer from "../../store";
import {
  getPartnerPromotionSettings,
  setPartnerPromotionSettings,
  setProducts,
  setSearchProductDialog,
  setShowTableRowCount,
  storePartnerPromotion,
  updatePartnerPromotion,
  viewPartnerPromotion,
} from "../../store/partnerPromotionSlice";
import PartnerProductsSearchModalWindow from "./PartnerProductSearchModalWindow";
import PartnerProductsJqx from "./PartnerProductsJqx";
import CommonDataTable from "../../../../share-components/table/commonDataTable";
import InfiniteScroll from "react-infinite-scroll-component";

const customStyles = {
  headCells: {
    style: {
      border: "1px solid #ccc",
      fontWeight: "bold",
    },
  },
  cells: {
    style: {
      border: "1px solid #ccc",
    },
  },
  //   rows: {
  //     style: {
  //       borderBottom: "1px solid #ccc",
  //     },
  //   },
};

export const defaultValues = {
  partner: null,
  name: "",
  percentage: "",
  start_date: "",
  end_date: null,
  agreed_by: "",
  is_partner_site_discount: false,
  partner_site_discount_percentage: 0,
  promotion_products: [],
  promotion_products_new: [],
};

export const schema = yup.object().shape({
  partner: yup.object().required("Partner is required").nullable(),
  name: yup.string().required("Name is required"),
  percentage: yup
    .number()
    .typeError("Percentage must be a number")
    .required("Percentage is required")
    .min(0, "Percentage cannot be less than 0")
    .max(100, "Percentage cannot be more than 100"),
  start_date: yup
    .date()
    .nullable()
    .required("Start date is required")
    .typeError("Start date is required")
    .max(yup.ref("end_date"), "Start date must be before or equal to end date"),
  end_date: yup
    .date()
    .nullable()
    .required("End date is required")
    .typeError("End date is required")
    .min(yup.ref("start_date"), "End date must be after or equal to start date"),
  agreed_by: yup.object().required("Agreed By is required").nullable(),
  is_partner_site_discount: yup.boolean().required(),
  partner_site_discount_percentage: yup
    .number()
    .typeError("Partner percentage must be a number")
    .when("is_partner_site_discount", {
      is: true,
      then: (schema) =>
        schema
          .required("Partner percentage is required")
          .moreThan(0, "Partner percentage must be greater than 0")
          .max(100, "Partner percentage cannot be more than 100"),
      otherwise: (schema) => schema.notRequired().nullable(),
    }),
});

function PartnerPromotionViewForm() {
  const { id } = useParams();
  let searchProductRef = useRef();
  let infiniteScrollRef = useRef();
  const history = useHistory();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [startDate, setStartDate] = useState(null);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [buttonDisable, setButtonDisable] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showData, setShowData] = useState([]);
  const partnerPromotionState = useSelector(({ partnerPromotion }) => partnerPromotion.partnerPromotion);
  const allSettings = useSelector(({ partnerPromotion }) => partnerPromotion.partnerPromotion?.partnerPromotionSetting?.setting);

  const pagination = partnerPromotionState?.products?.pagination || {};
  const totalProducts = pagination.total_products ?? 0;
  const totalItems = pagination.total_items ?? 0;

  const { handleSubmit, formState, reset, register, setValue, getValues, unregister, trigger, control, watch } = useForm({
    mode: "onChange",
    defaultValues,
    resolver: yupResolver(schema),
  });

  useEffect(() => {
    dispatch(getPartnerPromotionSettings()).then((res) => {
      dispatch(setPartnerPromotionSettings(res.payload));
    });
  }, [dispatch]);

  useEffect(() => {
    if (id) {
      if (infiniteScrollRef.current) {
        infiniteScrollRef.current.actionTriggered = false;
      }
      productSearchFunction(false, 1);
    }
  }, [searchTerm, id]);

  const isProvideOffer = watch("is_partner_site_discount");

  const { errors } = formState;
  const isError = Object.keys(errors).length > 0;

  const dataMenu = [
    {
      type: 1,
      text: "Partners Promotions",
      link: "/product/partners-promotions",
    },
    {
      type: 0,
      text: `View Promotion`,
      link: "",
    },
  ];

  const ourPercentage = getValues("percentage");

  const onPageSizeChange = (e) => {
    setPageSize(e);
    setPage(1);
  };

  const pageChange = (e) => {
    setPage(e);
  };

  const onSubmitForm = (data) => {};

  const productSearchFunction = (isConcat, page) => {
    let params = {
      name: searchTerm,
      page: page,
    };
    // if (!searchTerm) setLoading(true);

    dispatch(viewPartnerPromotion({ id, params })).then((res) => {
      if (!res.error) {
        reset(res.payload);
        setValue("partner", {
          value: getValues("partner").id,
          label: getValues("partner").name,
        });
        setValue("agreed_by", {
          value: getValues("agreed_by").id,
          label: getValues("agreed_by").name,
        });
        setValue("is_partner_site_discount", getValues("is_partner_site_discount") === 0 ? false : true);
        dispatch(setProducts({ data: res.payload.promotion_products, pagination: res.payload.pagination }));
        if (isConcat) {
          setShowData((prevArray) => [...prevArray, ...res.payload.promotion_products]);
          setLoading(false);
        } else {
          setShowData(res.payload.promotion_products);
          setLoading(false);
        }
      }
    });
  };

  const fetchProductData = () => {
    productSearchFunction(true, partnerPromotionState.products.pagination.next_page);
  };

  function handleGoBack() {
    history.push("/product/partners-promotions");
  }

  const calculatePriceAfterDiscount = (discount = 0,itemPrice, salePrice) => {
      let price = itemPrice === null ? salePrice : itemPrice;
      return +(price * (1 - discount / 100)).toFixed(2);
    };

  return (
    <Fragment>
      {loading ? (
        <>
          <PreLoader withoutText></PreLoader>
        </>
      ) : (
        <>
          <Breadcrumbs title={`View Promotion`} data={dataMenu} />
          <Container fluid={true} className="product-wrapper">
            <div className="product-grid">
              <div style={{ position: "fixed", top: "50%", zIndex: 10, right: 0 }}>
                <LogActivity log="Promotion" id={id} />
              </div>
              <Form onSubmit={handleSubmit(onSubmitForm)}>
                <Card style={{ padding: 24 }}>
                  <div className="invalid-feedback">{errors.partner && errors.partner.message}</div>
                  <Col sm="12">
                    <Row>
                      <Col md={4}>
                        <FormGroup>
                          <Label className="form-label" style={{ fontSize: "0.8rem", fontWeight: 500 }}>
                            Partner Name
                          </Label>
                          <CardText>{getValues("partner")?.label}</CardText>
                        </FormGroup>
                      </Col>
                      <Col md={4}>
                        <FormGroup>
                          <Label className="form-label" style={{ fontSize: "0.8rem", fontWeight: 500 }}>
                            Name
                          </Label>
                          <CardText>{getValues("name")}</CardText>
                        </FormGroup>
                      </Col>
                      <Col md={4}>
                        <FormGroup>
                          <Label className="form-label" style={{ fontSize: "0.8rem", fontWeight: 500 }}>
                            Percentage
                          </Label>
                          <CardText>{getValues("percentage") + " %"}</CardText>
                        </FormGroup>
                      </Col>
                      <Col md={4}>
                        <FormGroup>
                          <Label className="form-label" style={{ fontSize: "0.8rem", fontWeight: 500 }}>
                            Start Date
                          </Label>
                          <CardText>{getValues("start_date")}</CardText>
                        </FormGroup>
                      </Col>
                      <Col md={4}>
                        <FormGroup>
                          <Label className="form-label" style={{ fontSize: "0.8rem", fontWeight: 500 }}>
                            End Date
                          </Label>
                          <CardText>{getValues("end_date")}</CardText>
                        </FormGroup>
                      </Col>

                      <Col md={4}>
                        <FormGroup>
                          <Label className="form-label" style={{ fontSize: "0.8rem", fontWeight: 500 }}>
                            Agreed By
                          </Label>
                          <CardText>{getValues("agreed_by")?.label}</CardText>
                        </FormGroup>
                      </Col>

                      <Col md={4}>
                        <FormGroup className="">
                          <Label className="form-label" style={{ fontSize: "0.8rem", fontWeight: 500 }}>
                            Is Partner offering discount on their site ?
                          </Label>
                          <CardText>{getValues("is_partner_site_discount") ? "Yes" : "No"}</CardText>
                        </FormGroup>
                      </Col>

                      {isProvideOffer && (
                        <Col md={4}>
                          <FormGroup>
                            <Label className="form-label" style={{ fontSize: "0.8rem", fontWeight: 500 }}>
                              Partner Side Percentage Discount
                            </Label>
                            <CardText>{getValues("partner_site_discount_percentage") + " %"}</CardText>
                          </FormGroup>
                        </Col>
                      )}
                    </Row>
                  </Col>
                </Card>

                <Card style={{ padding: 24 }}>
                  <>
                    <>
                      <h5>Products</h5>
                      <Row style={{ marginBottom: "1rem" }}>
                        <Col>
                          <Input
                            type="text"
                            placeholder="Search Products"
                            name="products"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                          />
                        </Col>
                      </Row>
                    </>
                    <Row>
                      <Col md={12}>
                        <InfiniteScroll
                          ref={(scroll) => {
                            infiniteScrollRef.current = scroll;
                          }}
                          dataLength={showData.length}
                          next={fetchProductData}
                          hasMore={partnerPromotionState.products.pagination.has_more}
                          refreshFunction={() => {
                            alert("Test");
                          }}
                          pullDownToRefresh={true}
                          // onScroll={(e)=>{console.log(e)}}
                          height={400}
                          loader={<p>Load</p>}
                        >
                          <table
                            className="table"
                            style={{
                              width: "100%",
                              // height: 500,
                              // overflowY: "scroll",
                              display: "block",
                              borderCollapse: "collapse",
                              border: "1px solid #dee2e6",
                            }}
                          >
                            <thead>
                              <tr style={{ display: "table", width: "100%", tableLayout: "fixed", border: "1px solid #dee2e6" }}>
                                <th style={{ width: "40%", border: "1px solid #dee2e6" }}>Product</th>
                                <th style={{ width: "15%", textAlign: "center", border: "1px solid #dee2e6" }}>Stock</th>
                                <th style={{ width: "15%", textAlign: "center", border: "1px solid #dee2e6" }}>Sale Price</th>
                                <th style={{ width: "15%", textAlign: "center", border: "1px solid #dee2e6" }}>RRP</th>
                                <th style={{ width: "15%", textAlign: "center", border: "1px solid #dee2e6" }}>Price After Discount</th>
                              </tr>
                            </thead>
                            <tbody
                              style={{
                                display: "block",
                                // maxHeight: "340px",
                                // overflowY: "auto"
                              }}
                            >
                              {showData.length > 0 ? (
                                showData.map((item, i) => (
                                  <tr key={i} style={{ display: "table", width: "100%", tableLayout: "fixed", border: "1px solid #dee2e6" }}>
                                    <td style={{ width: "40%" }}>
                                      <div className="row" style={{ padding: 5 }}>
                                        <div className="col-md-4">
                                          <img className="img-fluid" src={item.image} style={{width:'50%', height:"auto"}} alt="" />
                                        </div>
                                        <div className="col-md-8">
                                          <p className="font-primary mb-0">{item.name}</p>
                                          <p className="mb-0">
                                            {item.colour ? `${item.colour} - ${item.size}` : ` ${item.size}`}
                                          </p>
                                          <p className="mb-0">{item.sku}</p>
                                        </div>
                                      </div>
                                    </td>
                                    <td style={{ width: "15%", textAlign: "center", border: "1px solid #dee2e6" }}>{item.current_stock}</td>
                                    <td style={{ width: "15%", textAlign: "center", border: "1px solid #dee2e6" }}>{Number(item.sale_price ?? 0).toFixed(2)}</td>
                                    <td style={{ width: "15%", textAlign: "center", border: "1px solid #dee2e6" }}>{Number(item.price ?? 0).toFixed(2)}</td>
                                    <td style={{ width: "15%", textAlign: "center", border: "1px solid #dee2e6" }}>
                                      {calculatePriceAfterDiscount(ourPercentage, item.price, item.price).toFixed(2)}
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr style={{ display: "table", width: "100%", tableLayout: "fixed", border: "1px solid #dee2e6" }}>
                                  <td colSpan={5} style={{ textAlign: "center", padding: "1rem", border: "1px solid #dee2e6" }}>
                                    No data found
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </InfiniteScroll>
                      </Col>
                    </Row>
                  </>

                  <div className="mt-3 d-flex justify-content-end align-items-end">
                     <div>
                        <strong>Total Products:</strong> {totalProducts}
                      </div>
                      <div className="mx-4">
                        <strong>Total Items:</strong> {totalItems}
                      </div>

                    <ButtonLoader color="primary" disabled={buttonDisabled} onClick={handleGoBack} btntext={`Go Back`} className="btn btn-primary" />
                  </div>
                </Card>
              </Form>
            </div>
          </Container>
        </>
      )}

      {/* <PartnerProductsSearchModalWindow setValue={setValue} getValues={getValues} trigger={trigger} searchTerm={searchTerm} onTagOrCollectionChange/> */}
    </Fragment>
  );
}

export default withReducer([{ partnerPromotion: partnerPromotionReducer }])(PartnerPromotionViewForm);
